'use client';

import { useDrawerStore } from '@/stores';

import { PaymentDrawer } from '../PaymentDrawer';

export const usePaymentDrawer = () => {
  const openDrawer = useDrawerStore((state) => state.openDrawer);
  const replaceDrawer = useDrawerStore((state) => state.replaceDrawer);
  const drawers = useDrawerStore((state) => state.drawers);

  const openPaymentDrawer = (onResetTimer?: () => void) => {
    const paymentDrawerConfig = {
      title: 'seu qr code expirou!',
      drawerHeaderOptions: { className: 'text-center uppercase' },
      Component: () => PaymentDrawer({ onResetTimer }),
      drawerType: 'payment',
    } as const;

    const hasOpenDrawer = drawers.length > 0;
    if (hasOpenDrawer) {
      replaceDrawer(paymentDrawerConfig);
    } else {
      openDrawer(paymentDrawerConfig);
    }
  };

  return { openPaymentDrawer };
};
